import ClinicSelectionForm, { schema } from "./ClinicSelectionForm";

export { schema };
export default ClinicSelectionForm;
